import { BarChart } from "@mui/x-charts/BarChart";
import React from "react";

const DEFAULT_DATASET = [
  {
    london: 59,
    paris: 57,
    newYork: 86,
    seoul: 21,
    month: "Small Appliance",
  },
  {
    london: 50,
    paris: 52,
    newYork: 78,
    seoul: 28,
    month: "A4 Envelope",
  },
  {
    london: 47,
    paris: 53,
    newYork: 106,
    seoul: 41,
    month: "Moving Box",
  },
];

const BarChartComponent = ({
  dataset,
  dataKey = "seoul",
  categoryKey = "month",
  label = "Parcel Cost",
  valuePrefix = "£",
  axisLabel = "Cost (£)",
  height = 260,
}) => {
  const rows = dataset == null ? DEFAULT_DATASET : dataset;
  const valueFormatter = (value) => `${valuePrefix}${value}`;

  return (
    <div className="w-full h-[280px]">
      <BarChart
        margin={{ left: 110, right: 16, top: 24, bottom: 24 }}
        dataset={rows}
        yAxis={[{ scaleType: "band", dataKey: categoryKey }]}
        series={[{ dataKey, label, color: "#FFA76A", valueFormatter }]}
        layout="horizontal"
        grid={{ vertical: true }}
        height={height}
        xAxis={[{ label: axisLabel }]}
      />
    </div>
  );
};

export default BarChartComponent;
